import { DialogType } from "@/enums/dialogType"

export default {
  namespaced: true,

  state: () => ({
    open: false,
    title: '',
    message: '',
    type: DialogType.SUCCESS
  }),

  mutations: {
    SHOW(state, payload) {
      state.title = payload.title
      state.message = payload.message
      state.type = payload.type || DialogType.SUCCESS
      state.open = true
    },

    CLOSE(state) {
      state.open = false
    }
  },

  actions: {
    show({ commit }, payload) {
      commit('SHOW', payload)
    },

    close({ commit }) {
      commit('CLOSE')
    }
  }
}
